<template>
  <div>
    <a class="btn-blue" @click="showing = true">Create Discount</a>
    <card-modal :showing="showing" class="px-4 py-2" @close="showing = false">
      <h2 class="font-bold text-3xl">Add Discount</h2>
      <form class="mt-6" @submit.prevent="store">
        <div class="flex items-center justify-between">
          <label class="form-label">Value</label>
          <text-input v-model="form.value" type="number" :step="0.01" min="0" :error="form.errors.value" class="w-1/2" />
        </div>
        <div class="flex items-center justify-end mt-6">
          <a class="border text-blue-800 border-blue-800 px-4 py-2 mr-4 cursor-pointer hover:text-white hover:bg-blue-600" @click.stop="showing = false">Cancel</a>
          <loading-button :loading="form.processing" class="btn-blue px-4 py-2" type="submit">Save Discount</loading-button>
        </div>
      </form>
    </card-modal>
  </div>
</template>

<script>
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'
import CardModal from '@/Shared/CardModal'

export default {
  components: {
    LoadingButton,
    TextInput,
    CardModal,
  },
  remember: 'form',
  data() {
    return {
      showing: false,
      form: this.$inertia.form({
        value : null,
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/discounts', {
        onSuccess: () => {
          this.form.reset()
          this.showing = false
        },
      })
    },
  },
}
</script>
